export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

function appendFormValue(formData, key, value) {
  if (Array.isArray(value)) {
    value.forEach(function(entry) {
      appendFormValue(formData, `${key}[]`, entry);
    });
    return;
  }

  if (typeof value === 'undefined') {
    return;
  }

  formData.append(key, value === null ? '' : String(value));
}

export function urlEncodedBody(data = {}) {
  const formData = new URLSearchParams();

  Object.keys(data || {}).forEach(function(key) {
    appendFormValue(formData, key, data[key]);
  });

  return formData;
}

export async function requestJson(url, options = {}) {
  const method = options.method || 'GET';
  const headers = Object.assign({ Accept: 'application/json' }, options.headers || {});
  const fetchOptions = {
    method,
    headers,
    signal: options.signal
  };

  if (options.cache) {
    fetchOptions.cache = options.cache;
  }

  if (method !== 'GET') {
    const token = csrfToken();

    if (token) {
      headers['X-CSRF-Token'] = token;
    }

    if (typeof options.data !== 'undefined') {
      headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
      fetchOptions.body = options.data instanceof URLSearchParams ? options.data : urlEncodedBody(options.data);
    }
  }

  const response = await fetch(url, fetchOptions);
  if (response.status === 304 || response.status === 204) {
    return null;
  }

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}
